import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router'
import {routes} from './routes'
import {store} from './store/store'
import axios from 'axios'

import 'material-design-icons-iconfont/dist/material-design-icons.css'

import Vuelidate from 'vuelidate'

import JsonExcel from 'vue-json-excel'
 
import "@/plugins/echarts";

import DatetimePicker from 'vuetify-datetime-picker'

Vue.use(DatetimePicker)

Vue.component('downloadExcel', JsonExcel)

Vue.use(Vuelidate)
Vue.use(VueRouter);

import VueCountdownTimer from 'vuejs-countdown-timer'
Vue.use(VueCountdownTimer)

//import CKEditor from '@ckeditor/ckeditor5-vue';
//by vrushali 
import CKEditor from 'ckeditor4-vue';

Vue.use( CKEditor );

import VueMathjax from 'vue-mathjax';
Vue.use(VueMathjax);

const router =new VueRouter({
  routes:routes,  //routes:routes
  mode: 'history', //  history to remove #
//  linkActiveClass: 'tag is-active',
  linkActiveClass: "active", // active class for non-exact links.
  linkExactActiveClass: "active" // active class for *exact* links.
})


Vue.config.productionTip = false
// axios.defaults.headers.get['Content-Type'] ='application/x-www-form-urlencoded';
axios.defaults.headers.get['Content-Type'] ='application/json';
axios.defaults.baseURL = process.env.VUE_APP_API_URL //live or local
//axios.defaults.baseURL = process.env.VUE_APP_API_URL_BETA //beta
axios.interceptors.request.use(config =>{
 // console.log("req-int"+navigator.onLine)
  if(!navigator.onLine){
    //alert("You are offline!!!")
  }

  if(localStorage.getItem("EPS-token"))
    config.headers.common['EPS-token']=localStorage.getItem("EPS-token")
  if(localStorage.getItem("EPS-uid"))
    config.headers.common['EPS-uid']=localStorage.getItem("EPS-uid") 
    config.headers.common['router-path']=router.currentRoute.path
  return config
})

axios.interceptors.response.use(res =>{
  console.log("res-url:"+res.request.responseURL)
  console.log("res-status:"+res.status)
  if (!navigator.onLine) {
    alert("You are offline!!!")
    return
}
  if(res.data.msg=="200"){
    if(res.data.token_status=="token-refreshed")
      localStorage.setItem("EPS-token",res.data.token)
  }
  else if(res.data.msg=="401"){
    localStorage.setItem('login-page-msg',"You are already logged in on a different device. Please login again")
    router.push("/")
  }
  else if(res.data.msg=="403"){
    
    localStorage.setItem('login-page-msg',"Access Denied!!!")
    router.push("/access-denied")
  }
  return res
})

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
